/** Libellés français pour les données de référence (noms API souvent en anglais). */

const VEHICLE_TYPE_LABELS: Record<string, string> = {
  'On foot': 'À pied',
  'Bicycle': 'Vélo',
  'Motorcycle': 'Moto',
  'Car': 'Voiture',
  'Truck': 'Camion',
};

const SPECIALIZATION_LABELS: Record<string, string> = {
  'Express': 'Express',
  'Fragile': 'Fragile',
  'Fresh/Frozen': 'Frais / Surgelés',
  'Large Volume': 'Gros volumes',
  'Documents': 'Documents',
  'Medicines': 'Médicaments',
};

const AVAILABILITY_SLOT_LABELS: Record<string, string> = {
  'Morning': 'Matin',
  'Afternoon': 'Après-midi',
  'Evening': 'Soirée',
  'Weekend': 'Week-end',
  'Public Holidays': 'Jours fériés',
};

export function vehicleTypeLabel(name: string): string {
  return VEHICLE_TYPE_LABELS[name] ?? name;
}

export function specializationLabel(name: string): string {
  return SPECIALIZATION_LABELS[name] ?? name;
}

export function availabilitySlotLabel(name: string): string {
  return AVAILABILITY_SLOT_LABELS[name] ?? name;
}
